<i class="{{ format }}" [ngStyle]="{'font-size': size, 'color': color}"></i>
